
export default function EspecialistasSection() {
  const outrasEspecialistas = [
    {
      name: 'Ana Carolina Hildebrandt',
      role: 'Especialista em Comunicação',
      image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/bff92abfcaf0f77ececa829e8d608e29.jpeg'
    },
    {
      name: 'Juliana Costa',
      role: 'Especialista em Liderança',
      image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/bd5feb73d7b13f63edb4e186a30bad83.jpeg'
    },
    {
      name: 'Maria Gabriela Montero',
      role: 'Especialista em Desenvolvimento',
      image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/023dcbd13fe9a034ee64cde852079951.jpeg'
    }
  ];

  return (
    <section id="especialistas" className="py-24 bg-purple-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-5xl lg:text-6xl font-bold text-white text-center mb-4">
          Quem vai te guiar
        </h2>
        <p className="text-xl text-white/80 text-center mb-16 max-w-3xl mx-auto">
          Aprenda com <strong>especialistas experientes</strong> e reconhecidas no mercado, além de convidadas especiais em cada módulo
        </p>

        <div className="flex flex-col lg:flex-row gap-8 items-stretch">
          {/* Tati Marzullo - Destaque */}
          <div className="lg:w-2/5 flex flex-col">
            <div className="bg-purple-800/50 rounded-3xl p-8 flex-1 flex flex-col">
              <div className="inline-block bg-gold-500 text-purple-900 px-4 py-1 rounded-full text-sm font-bold mb-6 self-start">
                Fundadora
              </div>
              <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden mb-6">
                <img
                  src="https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/dc09147ba51664f2bfe37ca4dbc7af82.jpeg"
                  alt="Tati Marzullo"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-auto">
                <h3 className="text-gold-500 text-2xl font-bold mb-1">TATI MARZULLO:</h3>
                <p className="text-white/90 text-lg">
                  CEO e fundadora da Agência A+, Agency A+ e Programa Salto Alto
                </p>
              </div>
            </div>
          </div>

          {/* Outras Especialistas */}
          <div className="lg:w-3/5 flex flex-col gap-6">
            {outrasEspecialistas.map((especialista, index) => (
              <div
                key={index}
                className="bg-purple-800/50 rounded-3xl p-6 flex items-center gap-6 hover:bg-purple-800/70 transition-all duration-300 cursor-pointer flex-1"
              >
                <div className="w-24 h-24 flex-shrink-0 rounded-full overflow-hidden">
                  <img
                    src={especialista.image}
                    alt={especialista.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-1">{especialista.name}</h3>
                  <p className="text-white/70">{especialista.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/80 text-lg">
            + Convidadas especiais em cada módulo
          </p>
        </div>
      </div>
    </section>
  );
}
